import { retrieve, update } from "framework/http/endpoint";
import { createCollectionResponseFactory, createEntityResponseFactory } from "framework/http/rest/jsonResponse";
import { fromApiTransportDate } from "framework/http/transport";
import { UrlPathOfApiLocation } from "common/paths";
var ApiUriPrefix = "".concat(UrlPathOfApiLocation, "/api/1/national_teams");
function apiGetNationalTeams() {
    var uri = ApiUriPrefix;
    return retrieve(uri, null, createCollectionResponseFactory(fromTransportNationalTeam));
}
function apiGetNationalTeam(nrtId) {
    var uri = "".concat(ApiUriPrefix, "/").concat(nrtId);
    return retrieve(uri, null, createEntityResponseFactory(fromTransportNationalTeamMember));
}
function apiPublishNationalTeam(nationalTeamId) {
    var uri = "".concat(ApiUriPrefix, "/").concat(nationalTeamId, "/publish");
    return update(uri, null, createEntityResponseFactory(fromTransportNationalTeam));
}
function apiHideNationalTeam(nationalTeamId) {
    var uri = "".concat(ApiUriPrefix, "/").concat(nationalTeamId, "/hide");
    return update(uri, null, createEntityResponseFactory(fromTransportNationalTeam));
}
function fromTransportNationalTeam(entity) {
    entity.fromDate = fromApiTransportDate(entity.fromDate);
    entity.toDate = fromApiTransportDate(entity.toDate);
    return entity;
}
function fromTransportNationalTeamMember(entity) {
    return entity;
}
export { apiGetNationalTeams, apiGetNationalTeam, apiPublishNationalTeam, apiHideNationalTeam, };
